export const hideAxeptioButton = (): void => {
  globalThis._axcb = globalThis._axcb ?? [];

  // Wait for Axeptio to be ready
  // @see https://developers.axeptio.eu/cookies/axeptio-javascript-sdk#using-a-callback-function-to-get-a-reference-to-the-sdk
  globalThis._axcb.push(() => {
    if (globalThis.hideAxeptioButton === undefined) {
      throw new Error('Callback "hideAxeptioButton" manquant.');
    }

    globalThis.hideAxeptioButton();
  });
};

export const openAxeptioCookiesManagement = (): void => {
  if (typeof globalThis.openAxeptioCookies === 'function' && typeof globalThis.hideAxeptioButton === 'function') {
    globalThis.openAxeptioCookies();
    // Hide Axeptio button again as it shows up automatically after calling openAxeptioCookies()
    globalThis.hideAxeptioButton();
  }
};
